import { render, staticRenderFns } from "./invite-public.vue?vue&type=template&id=66cbd5f6&"
import script from "./invite-public.vue?vue&type=script&lang=js&"
export * from "./invite-public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports